import axios from "axios";
import { API_URL } from './../config/index';

export const authHeaders = () => {
    const token = localStorage.getItem("token");

    return {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/x-www-form-urlencoded',
        }
    }
}

export const authHeadersImage = () => {
    const token = localStorage.getItem("token");

    return {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/x-www-form-urlencoded",
        }
    }
}

const Axios = axios.create({
    baseURL: API_URL
})

export default Axios;